import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import { NewsWidget } from '@/core/widgets/export';
import DashboardAddItemControl from '@/app/dashboard/components/dashboard-add-item-control';
import '@/shared/theme/navbar-buttons.scss';

export default function DashboardEditControls({
  dashboardName,
  onDashboardNameChange,
  onSaveDashboard,
  onAddWidget,
  activeWidgets,
}: {
  dashboardName: string;
  onDashboardNameChange: (s: string) => void;
  onSaveDashboard: () => void;
  onAddWidget: (w: string) => void;
  activeWidgets: NewsWidget[];
}) {
  return (
    <div className={'d-flex align-items-center'}>
      <input
        type="text"
        className={'form-control form-control-sm navbar-btn me-3'}
        style={{ width: 223 }}
        onChange={e => {
          e.preventDefault();
          e.stopPropagation();
          onDashboardNameChange(e.target.value);
        }}
        value={dashboardName}
      ></input>

      <button
        style={{ fontFamily: 'Inter' }}
        className={'btn btn-outline-primary-500 btn-sm navbar-btn navbar-btn-square me-3'}
        onClick={() => onSaveDashboard()}
      >
        <FontAwesomeIcon icon={faFloppyDisk} style={{ fontSize: '1.15em' }} />
      </button>

      <DashboardAddItemControl onAddWidget={onAddWidget} activeWidgets={activeWidgets} />
    </div>
  );
}
